export const SET_SAVED_CANDIDATES_LOADING = "SET_SAVED_CANDIDATES_LOADING";
export const SET_SAVED_CANDIDATES_ERROR = "SET_SAVED_CANDIDATES_ERROR";

export const FETCH_SAVED_CANDIDATES_BY_DEMANDE_REQUEST = "FETCH_SAVED_CANDIDATES_BY_DEMANDE_REQUEST";
export const FETCH_SAVED_CANDIDATES_BY_DEMANDE_SUCCESS = "FETCH_SAVED_CANDIDATES_BY_DEMANDE_SUCCESS";
export const FETCH_SAVED_CANDIDATES_BY_DEMANDE_FAIL = "FETCH_SAVED_CANDIDATES_BY_DEMANDE_FAIL";

export const SAVE_CANDIDATE_FOR_DEMANDE_REQUEST = "SAVE_CANDIDATE_FOR_DEMANDE_REQUEST";
export const SAVE_CANDIDATE_FOR_DEMANDE_SUCCESS = "SAVE_CANDIDATE_FOR_DEMANDE_SUCCESS";
export const SAVE_CANDIDATE_FOR_DEMANDE_FAIL = "SAVE_CANDIDATE_FOR_DEMANDE_FAIL";

export const UNSAVE_CANDIDATE_FOR_DEMANDE_REQUEST = "UNSAVE_CANDIDATE_FOR_DEMANDE_REQUEST";
export const UNSAVE_CANDIDATE_FOR_DEMANDE_SUCCESS = "UNSAVE_CANDIDATE_FOR_DEMANDE_SUCCESS";
export const UNSAVE_CANDIDATE_FOR_DEMANDE_FAIL = "UNSAVE_CANDIDATE_FOR_DEMANDE_FAIL";

export const setSavedCandidatesLoading = (v) => ({
    type: SET_SAVED_CANDIDATES_LOADING,
    payload: v,
});

export const setSavedCandidatesError = (msg) => ({
    type: SET_SAVED_CANDIDATES_ERROR,
    payload: msg,
});

export const fetchSavedCandidatesByDemandeRequest = (demandeId) => ({
    type: FETCH_SAVED_CANDIDATES_BY_DEMANDE_REQUEST,
    payload: { demandeId },
});

export const fetchSavedCandidatesByDemandeSuccess = (data) => ({
    type: FETCH_SAVED_CANDIDATES_BY_DEMANDE_SUCCESS,
    payload: data,
});

export const fetchSavedCandidatesByDemandeFail = (err) => ({
    type: FETCH_SAVED_CANDIDATES_BY_DEMANDE_FAIL,
    payload: err,
});

export const saveCandidateForDemandeRequest = (payload) => ({
    type: SAVE_CANDIDATE_FOR_DEMANDE_REQUEST,
    payload,
});

export const saveCandidateForDemandeSuccess = (data) => ({
    type: SAVE_CANDIDATE_FOR_DEMANDE_SUCCESS,
    payload: data,
});

export const saveCandidateForDemandeFail = (err) => ({
    type: SAVE_CANDIDATE_FOR_DEMANDE_FAIL,
    payload: err,
});

export const unsaveCandidateForDemandeRequest = (demandeId, candidatId) => ({
    type: UNSAVE_CANDIDATE_FOR_DEMANDE_REQUEST,
    payload: { demandeId, candidatId },
});

export const unsaveCandidateForDemandeSuccess = (payload) => ({
    type: UNSAVE_CANDIDATE_FOR_DEMANDE_SUCCESS,
    payload,
});

export const unsaveCandidateForDemandeFail = (err) => ({
    type: UNSAVE_CANDIDATE_FOR_DEMANDE_FAIL,
    payload: err,
});